import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import request from '@vaersaagod/tools/Request';
import 'gsap';

export default (el, props) => {
    const $el = $(el);
    const $target = $el.find('[data-paginated-list-wrap]');
    const $navWrap = $el.find('[data-paginated-nav-wrap]');
    const $navLink = $el.find('[data-paginated-nav-link]');
    
    let req = null;
    
    const loadContent = url => {
        //TweenLite.to($target.get(0), 0.1, { opacity: 0 });
        
        request
            .get(url)
            .type('text/html')
            .then(res => {
                const { status, text } = res || {};
                if (status === 200 && text) {
                    insertContent(text);
                    //TweenLite.to($target.get(0), 0.1, { opacity: 1 });
                } else {
                    // Do something else
                }
            })
            .catch(error => {
                console.error(error);
            });
    };
    
    const insertContent = content => {
        const $content = $(`<div>${content}</div>`);
        const $newTargetContent = $content.find('[data-paginated-list-wrap] > *');
        const $newPaginateLink = $content.find('[data-paginated-nav-link]');
        
        console.log($newTargetContent);
        $target.append($newTargetContent);
        
        if ($newPaginateLink.length > 0) {
            $navLink.attr('href', $newPaginateLink.attr('href'));
        } else {
            $navWrap.css('display', 'none'); 
        }
    };
    
    const init = () => {
        $el.addClass('js-inited');
        
        $el.on('click', '[data-paginated-nav-link]', e => {
            e.preventDefault();
            loadContent($(e.triggerTarget).attr('href'));
        });
    };

    const destroy = () => {
        $el.off('click');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/PaginatedList.js